var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useReducer } from "react";
var initialState = {
    checked: [],
};
var reducer = function (state, action) {
    switch (action.type) {
        case "TOGGLE_CHECKBOX": {
            var exists = state.checked.some(function (item) { return item.trxId === action.payload.trxId; });
            return {
                checked: exists
                    ? state.checked.filter(function (item) { return item.trxId !== action.payload.trxId; })
                    : __spreadArray(__spreadArray([], __read(state.checked), false), [action.payload], false),
            };
        }
        case "TOGGLE_ALL": {
            return {
                checked: state.checked.length === action.payload.length ? [] : action.payload,
            };
        }
        case "RESET":
            return initialState;
        default:
            return state;
    }
};
export var useCheckboxHandler = function (data) {
    var _a = __read(useReducer(reducer, initialState), 2), state = _a[0], dispatch = _a[1];
    var handleCheck = function (event) {
        var trxId = event.target.value;
        dispatch({
            type: "TOGGLE_CHECKBOX",
            payload: { trxId: Number(trxId) },
        });
    };
    var handleSelectAll = function (event) {
        dispatch({
            type: "TOGGLE_ALL",
            payload: event.target.checked ? data : [],
        });
    };
    var resetSelection = function () {
        dispatch({ type: "RESET" });
    };
    return {
        checked: state.checked,
        handleCheck: handleCheck,
        handleSelectAll: handleSelectAll,
        resetSelection: resetSelection,
    };
};
